import * as React from 'react';
import { View } from '@/core';

const Wrapper: React.FC = (props) => {
	return <View {...props} />;
};

export default Wrapper;
